<template>
  <div class="base-feature-checkprice">
    <div class="base-feature-checkprice__wrap">
      <div class="base-feature-checkprice__wrap__form">
        <div class="base-feature-checkprice__wrap__form__origin">
          <InputLocation
            id="origin"
            v-model="origin.route_code"
            origin-or-destination="origin"
            name="origin"
            placeholder="Masukkan kota asal"
            label="Asal"
            @click="clickOrigin"
            @input="getListOriginSearch"
          />
          <OptionSelect
            v-if="showOrigin"
            class="option-select"
            decide-class-hover="hover-option-from"
            trigger-class-listener-on-scroll="option-select__content-from"
            style-display="z-index: 20;width: 100%"
            key-value="route_code"
            :show-loading-search="loading"
            :data-list="GET_LIST_ORIGIN"
            @click="chooseOrigin"
          />
        </div>
        <div class="base-feature-checkprice__wrap__form__destination">
          <InputLocation
            id="destination"
            v-model="destination.route_code"
            origin-or-destination="destination"
            name="destination"
            placeholder="Masukkan kota tujuan"
            label="Tujuan"
            @click="clickDestination"
            @input="getListDestinationSearch"
          />
          <OptionSelect
            v-if="showDestination"
            decide-class-hover="hover-option-from"
            trigger-class-listener-on-scroll="option-select__content-from"
            style-display="z-index: 20;width: 100%"
            key-value="route_code"
            :show-loading-search="loading"
            :data-list="GET_LIST_DESTINATION"
            @click="chooseDestination"
          />
        </div>
        <div class="base-feature-checkprice__wrap__form__weight">
          <div class="base-feature-checkprice__wrap__form__weight__wrap">
            <div
              v-for="(weightChoice, id) in weightChoices"
              :id="`btn_${weightChoice.weight}kg_new`"
              :key="id"
              :class="id === choiceActive || weight === weightChoice.weight ? 'active' : ''"
              class="base-feature-checkprice__wrap__form__weight__wrap__item"
              @click="changeChoice(weightChoice)"
            >
              {{ weightChoice.weight }} kg
            </div>
          </div>
          <div class="base-feature-checkprice__wrap__form__weight__input">
            <input
              id="weight"
              v-model="weight"
              name="weight"
              placeholder="Berat"
              tabindex="0"
              autocomplete="off"
              @input="handleOnChangeWeight(weight)"
              @paste="$event.preventDefault()"
            >
            <div class="base-feature-checkprice__wrap__form__weight__input__note">
              kg
            </div>
          </div>
        </div>
      </div>
      <div class="base-feature-checkprice__wrap__btn">
        <Button
          id="btn_cek_tarif_new"
          text="Cek tarif"
          type-class="indigo-dark"
          :round="true"
          :disabled="checkDisabled"
          @click="checkprice"
        />
      </div>
    </div>
    <modal-recaptcha
      id="check-price-captcha"
      v-model="isModalRecaptcha"
      @response="onCaptchaResponse"
      @expired="onCaptchaExpired"
      @error="onCaptchaError"
      @widget-id="(res) => {recaptchaWidgetId = res}"
      @close="() => { isModalRecaptcha = false }"
    />
  </div>
</template>

<script>
import mixinMobile from '@/misc/mixinMobile';
import Button from "@/components/new-button/Button.vue";
import InputLocation from "./InputLocation.vue";
import OptionSelect from "@/components/new-option-select/OptionSelect.vue";
import { mapGetters } from "vuex";
import service from '@/app/usecase/routeOriginAndDestination';
import ModalRecaptcha from '@/components/new-modal/ModalRecaptcha.vue';
import mixinRecaptcha from '@/components/new-modal/mixinRecaptcha.js';
import routeAlgo from "@/app/usecase/routeOrder";

export default {
  name: "FeatureSectionCheckPriceHome",
  components: {
    Button,
    InputLocation,
    OptionSelect,
    ModalRecaptcha,
  },
  mixins: [mixinMobile, mixinRecaptcha],
  data() {
    return {
      weightChoices: [
        {
          id: 0,
          weight: '1',
        },
        {
          id: 1,
          weight: '2',
        },
        {
          id: 2,
          weight: '10',
        },
      ],
      choiceActive: 0,
      weight: '1',
      origin: {
        route_code: "",
        route_id: 0,
        district_code: ""
      },
      destination: {
        route_code: "",
        route_id: 0,
        district_code: ""
      },
      showOrigin: false,
      showDestination: false,
      loading: false,
      isModalRecaptcha: false,
      recaptchaWidgetId: null,
      isFirstLoadOrigin: true,
      isFirstLoadDestination: true,
      debounce: {
        timeout: 0,
        duration: 1500,
      },
    }
  },
  computed: {
    checkDisabled() {
      return this.origin.route_code && this.destination.route_code && this.weight.length < 1;
    },
    ...mapGetters(["GET_LIST_ORIGIN", "GET_LIST_DESTINATION"]),
    IS_GENESIS() {
      return process.env.VUE_APP_IS_GENESIS === 'true'
    },
  },
  mounted() {
    this.setCaptchaExistLs()
    this.getLocation()
  },
  methods: {
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.success, this.error);
      }
    },
    async success(position) {
      const filtersLocation = [
        "é=e",
        "kota bks=kota bekasi",
        "south tarogong=tarogong kidul",
        "sanankulon=sanan kulon",
        "daerah=",
        "khusus=",
        "ibukota=",
        "ibu kota=",
        "kota=",
        "city=",
        "special=",
        "istimewa=",
        "region=",
        "kabupaten=",
        "kab=",
        "sub-district=",
        "kecamatan=",
        "kec=",
        "regency="
      ]
      await routeAlgo.getReverseRoute(position.coords.latitude, position.coords.longitude).then(
        async res => {
          const location = {
            district: res.data.district,
            subDistrict: res.data.sub_district,
            routeId: 0,
          }
          for (const filter of filtersLocation) {
            let [key, value] = filter.split('=')
            res.data.district = res.data.district.toLowerCase().replace(new RegExp(key, 'g'), value).trim()
            res.data.sub_district = res.data.sub_district.toLowerCase().replace(new RegExp(key, 'g'), value).trim()
            location.district = res.data.district
            location.subDistrict = res.data.sub_district
          }
          // set
          this.origin.route_code = location.subDistrict
          this.getListOriginSearch(location.subDistrict)
          this.isFirstLoadOrigin = false
          
          // await routeAlgo.getAllBySearch(`${location.subDistrict}, ${location.district}`).then(resRoute => {
          //   if (resRoute.data.length > 0) {
          //     // choose first index because based on the search result on the top
          //     location.district = resRoute.data[0].city
          //     location.subDistrict = resRoute.data[0].route
          //   }
          //   this.origin.route_code = location.subDistrict
          //   this.getListOriginSearch(location.subDistrict)
          // })
        }
      )
    },
    error() {
      console.error("Geolocation not allowed");
    },
    chooseDestination(data) {
      if (this.IS_GENESIS) {
        this.destination.district_code = data.district_code
      }
      this.destination.route_code = data.route_code
      this.destination.route_id = data.route_id
      this.showDestination = false
    },
    clickDestination() {
      this.showDestination = !this.showDestination
      this.showOrigin = false
      if (this.showDestination && this.isFirstLoadDestination) this.getListDestination()
    },
    async getListDestination() {
      if (this.debounce.timeout) {
        clearTimeout(this.debounce.timeout)
      }
      this.loading = true
      this.debounce.timeout = setTimeout(async () => {
        const listDestination = await service.getAllDefault('destination');
        this.$store.dispatch('setListDestination', listDestination)
        this.isFirstLoadDestination = false
        this.loading = false
      }, this.debounce.duration)
    },
    async getListDestinationSearch(value) {
      if (this.debounce.timeout) {
        clearTimeout(this.debounce.timeout)
      }
      this.showDestination = true
      this.loading = true
      this.debounce.timeout = setTimeout(async () => {
        const listDestinationSearch = await service.getAllBySearch('destination', value);
        this.$store.dispatch('setListDestination', listDestinationSearch)
        this.loading = false
      }, this.debounce.duration)
    },
    chooseOrigin(data) {
      if (this.IS_GENESIS) {
        this.origin.district_code = data.district_code
      }
      this.origin.route_code = data.route_code
      this.origin.route_id = data.route_id
      this.showOrigin = false
    },
    clickOrigin() {
      this.showOrigin = !this.showOrigin
      this.showDestination = false
      if (this.showOrigin && this.isFirstLoadOrigin) this.getListOrigin()
    },
    async getListOrigin() {
      if (this.debounce.timeout) {
        clearTimeout(this.debounce.timeout)
      }
      this.loading = true
      this.debounce.timeout = setTimeout(async () => {
        const listOrigin = await service.getAllDefault('origin');
        this.$store.dispatch('setListOrigin', listOrigin)
        this.isFirstLoadOrigin = false
        this.loading = false
      }, this.debounce.duration)
    },
    async getListOriginSearch(value) {
      if (this.debounce.timeout) {
        clearTimeout(this.debounce.timeout)
      }
      this.showOrigin = true
      this.loading = true
      this.debounce.timeout = setTimeout(async () => {
        const listOriginSearch = await service.getAllBySearch('origin', value);
        this.$store.dispatch('setListOrigin', listOriginSearch)
        this.loading = false
      }, this.debounce.duration)
    },
    checkprice() {
      this.setIsCaptchaExist()
      if (!this.captchaResponse && this.isCaptchaExist) {
        this.isModalRecaptcha = true
      } else {
        this.getCheckPrice()
      }
    },
    onCaptchaResponse(res) {
      this.captchaResponse = res
      localStorage.setItem('captcha_is_exist', false)
      this.isCaptchaExist = false
      this.getCheckPrice()
    },
    getCheckPrice() {
      this.$router.push("/tarif")
      const payload = {
        origin: this.IS_GENESIS ? this.origin.district_code.toUpperCase() : this.origin.route_code.toUpperCase(),
        destination: this.IS_GENESIS ? this.destination.district_code.toUpperCase() : this.destination.route_code.toUpperCase(),
        weight: +this.weight.replace(',', '.'),
        captcha: this.captchaResponse || 'captcha',
        use_captcha: Boolean(this.captchaResponse)
      };
      if (this.IS_GENESIS) {
        payload.route_code_origin = this.origin.route_code.toUpperCase()
        payload.route_code_destination = this.destination.route_code.toUpperCase()
      }
      const form = {
        from: this.origin,
        to: this.destination,
        weight: this.weight,
      }
      this.$store.dispatch('initFillFormShippingPrice', form).then(() => {
        this.isModalRecaptcha = false
      })
      this.$store.dispatch('initCheckPrice', payload).then(() => {
        window.grecaptcha.reset(this.recaptchaWidgetId)
        this.onCaptchaReset()
      });
    },
    changeChoice(weightChoice) {
      this.choiceActive = weightChoice.id;
      this.weight = weightChoice.weight;
    },
    handleOnChangeWeight(text) {
      const checkDotComma = (this.weight.match(/\./g) || []).length + (this.weight.match(/,/g) || []).length > 1
      const allowNumberDotComma = (/^[0-9.,]+$/.test(text))
      const alphabet = /([A-z])/g

      if (isNaN(text.charAt(0)) || (!allowNumberDotComma && text) || checkDotComma) {
        this.weight = this.weight.slice(0, -1)
        document.querySelector("[name='weight']").value = this.weight
      }
      
      //handle swift keyboard
      if(alphabet.test(text)) {
        this.weight = this.weight.substring(0, this.weight.length - (this.weight.match(alphabet) || []).length)
        document.querySelector("[name='weight']").value = this.weight
      }

      if (text.length > 4 && +text.replace(',', '.') > 1000) {
        this.weight = this.weight.substring(0, 3)
      } else if (+text.replace(',', '.') > 1000) {
        this.weight = "1000"
      }

      //remove choice active
      this.choiceActive = null
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/style.scss";

.base-feature-checkprice {
  &__wrap {
    ::v-deep input[name='origin'],
    ::v-deep input[name='destination'] {
      text-transform: capitalize;
      font-size: 16px;
      color: $color-indigo-dark;
    }

    display: flex;
    padding: 30px 40px;

    @include for-size(mobile) {
      flex-direction: column;
      padding: 16px;
    }

    @include for-size(mobile-landscape) {
      flex-direction: column;
      padding: 16px;
    }

    @media (min-width: 916px) and (max-width: 1023px) {
      flex-direction: column;
      padding: 16px;
    }

    @include for-size(tablet-portrait) {
      flex-direction: column;
      padding: 16px;
    }

    @include for-size(tablet-landscape-new) {
      flex-direction: column;
      padding: 16px;
    }

    @media (min-width: 690px) and (max-width: 690px) {
      flex-direction: column;
      padding: 16px;
    }

    &__form {
      width: 88.5%;
      display: flex;

      &__origin {
        width: 30%;
        margin-right: 12px;

        @include for-size(mobile) {
          width: auto;
          margin-right: unset;
        }
      }

      &__destination {
        width: 30%;
        margin-right: 12px;

        @include for-size(mobile) {
          width: auto;
          margin-right: unset;
        }
      }

      .option-select {
        font-size: 14px;

        ::v-deep .lds-ellipsis {
          left: 40% !important;

          @include for-size(mobile-landscape) {
            left: 42% !important;
          }
        }
      }

      &__weight {
        width: auto;
        display: flex;
        align-items: center;

        &__wrap {
          display: flex;
          margin-right: 24px;

          @include for-size(mobile) {
            margin-right: 8px;
          }

          &__item {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
            width: 82px;
            padding: 8px 12px;
            background-color: white;
            border: 1px solid $color-gray-pensive-3;
            border-radius: 250px;
            cursor: pointer;
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            text-align: center;
            color: $color-indigo-dark;

            @include for-size(mobile) {
              width: 70px;
              height: 40px;
              font-size: 12px;
              line-height: 16px;
            }

            &.active {
              background-color: $color-gray-pensive;
              border: 1px solid $color-indigo-dark;
            }
          }

          &__item:not(:last-of-type) {
            margin-right: 4px;
          }
        }

        &__input {
          display: flex;
          align-items: center;
          width: 80px;
          border-bottom: 1px solid $color-border-primary;

          input {
            width: 55px;
            border: none;
            padding: 0;
            height: 50px;
            font-size: 16px;

            @include for-size(mobile) {
              width: 48px;
              font-size: 14px;
            }
          }

          input:focus {
            outline: none;
          }

          input[type="text"]::placeholder {
            color: $color-gray-shade;
            font-size: 16px!important;

            @include for-size(mobile) {
              font-size: 14px !important;
            }
          }

          &__note {
            display: flex;
            align-items: center;
            height: 20px;
            font-size: 16px;
            line-height: 24px;
            font-weight: 600;
            color: $color-base-text;
            border-left: 1px solid $color-gray-pensive-5;
            padding-left: 8px;
          }
        }
      }

      @include for-size(mobile) {
        flex-direction: column;
        width: auto;
        margin-bottom: 20px;

        &__origin {
          width: auto;
          margin-bottom: 8px;
        }

        &__destination {
          width: auto;
          margin-bottom: 8px;
        }
      }

      @include for-size(mobile-landscape) {
        flex-direction: column;
        width: auto;
        margin-bottom: 20px;

        &__origin {
          width: auto;
          margin-bottom: 8px;
        }

        &__destination {
          width: auto;
          margin-bottom: 8px;
        }
      }

      @media (min-width: 916px) and (max-width: 1023px) {
        flex-direction: column;
        width: auto;
        margin-bottom: 20px;

        &__origin {
          width: auto;
          margin-bottom: 8px;
        }

        &__destination {
          width: auto;
          margin-bottom: 8px;
        }
      }

      @include for-size(tablet-portrait) {
        flex-direction: column;
        width: auto;
        margin-bottom: 20px;

        &__origin {
          width: auto;
          margin-bottom: 8px;
        }

        &__destination {
          width: auto;
          margin-bottom: 8px;
        }
      }

      @include for-size(tablet-landscape-new) {
        flex-direction: column;
        width: auto;
        margin-bottom: 20px;

        &__origin {
          width: auto;
          margin-bottom: 8px;
        }

        &__destination {
          width: auto;
          margin-bottom: 8px;
        }
      }

      @media (min-width: 690px) and (max-width: 690px) {
        flex-direction: column;
        width: auto;
        margin-bottom: 20px;

        &__origin {
          width: auto;
          margin-bottom: 8px;
        }

        &__destination {
          width: auto;
          margin-bottom: 8px;
        }
      }
    }

    &__btn {
      width: 11.5%;
      margin: auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      ::v-deep .disabled {
        border-radius: 250px;
        height: 62px;
        width: max-content;
        display: flex;
        justify-content: center;
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
        border: unset;
      }

      > div {
        height: 62px;
        width: max-content;
        display: flex;
        justify-content: center;
        font-size: 20px;
        line-height: 24px;
        font-weight: 600;
      }

      @include for-size(mobile) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @include for-size(mobile-landscape) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @media (min-width: 916px) and (max-width: 1023px) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @include for-size(tablet-portrait) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @include for-size(tablet-landscape-new) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }

      @media (min-width: 690px) and (max-width: 690px) {
        width: 100%;

        ::v-deep .disabled {
          border-radius: 250px;
          height: 40px;
          width: 100%;
          font-size: 12px;
          line-height: 15px;
          font-weight: 600;
          border: unset;
        }

        > div {
          width: 100%;
          height: 40px;
          font-size: 12px;
          line-height: 15px;
        }
      }
    }
  }
}
</style>
